import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SigninListService {
  private http = inject(HttpClient);

  getLists(names: string, apiParams: Record<string, any> = {}, token?: string): Observable<any> {
    const url = `${environment.apiUrl}/api/dropdowns`;
    return this.http.get<any>(url, this.buildOptions({ names, ...apiParams }, token));
  }

  getListsForCompany(
    companyId: string | number,
    names: string,
    apiParams: Record<string, any> = {},
    token?: string
  ): Observable<any> {
    const url = `${environment.apiUrl}/api/companies/${companyId}/dropdowns`;
    return this.http.get<any>(url, this.buildOptions({ names, ...apiParams }, token));
  }

  private buildOptions(params: Record<string, any>, token?: string) {
    const options: any = { params: this.toHttpParams(params) };
    if (token) {
      options.headers = new HttpHeaders({ Authorization: token });
    }
    return options;
  }

  private toHttpParams(obj: Record<string, any>): HttpParams {
    let httpParams = new HttpParams();
    for (const key of Object.keys(obj)) {
      const val = obj[key];
      if (val !== null && val !== undefined && val !== '') {
        httpParams = httpParams.append(key, String(val));
      }
    }
    return httpParams;
  }
}
